import { createReducer, MetaReducer, on } from '@ngrx/store';
import { cloneDeep, get, merge, set } from 'lodash';

import { hydrationActions } from '../actions/hydration.actions';

const hydrationReducer = createReducer(
  {},
  on(hydrationActions.hydrateSuccess, (state, { element, newState }) => {
    const workingState = state ? cloneDeep(state) : {};
    const mergedValue = merge({}, get(workingState, element.key), newState);
    return set(workingState, element.key, mergedValue);
  })
);

export const metaReducer: MetaReducer = (reducer) => {
  return (state, action) =>
    action.type === hydrationActions.hydrateSuccess.type ? hydrationReducer(state, action) : reducer(state, action);
};
